import { LinkProps } from 'react-router-dom';

import { TableRow, TableRowProps, makeStyles } from '@material-ui/core';

import classNames from 'classnames';

import { useNavigate } from '../../behaviors';

const isExternalUrl = (to: LinkProps['to']): boolean =>
  typeof to === 'string' && /^([a-z+.-]+):/.test(to);

const useStyles = makeStyles(() => ({
  row: {
    cursor: 'pointer',
  },
}));

export type LinkableTableRowProps = TableRowProps & { to: LinkProps['to'] };

export const LinkableTableRow = ({
  children,
  to,
  hover = true,
  ...tableRowProps
}: LinkableTableRowProps) => {
  const navigate = useNavigate();
  const classes = useStyles();

  const handleClick = (event: React.MouseEvent<HTMLTableRowElement>) => {
    if (!to) return;

    const target = event.target as Element | null;
    const clickedInAnchor = Boolean(target && target.closest('a'));
    // Skip if user clicked inside a link — the link handles its own navigation
    if (clickedInAnchor) return;

    const url = typeof to === 'string' ? to : to.pathname || '';
    const external = isExternalUrl(to);

    if (event.metaKey || event.ctrlKey || external) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }

    navigate(to);
  };

  return (
    <TableRow
      hover={hover}
      className={classNames(classes.row, tableRowProps.className)}
      onClick={handleClick}
      {...tableRowProps}
    >
      {children}
    </TableRow>
  );
};
